"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCountDownTimer = require("./useCountDownTimer");
Object.keys(_useCountDownTimer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCountDownTimer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCountDownTimer[key];
    }
  });
});